import { Canvas } from "@react-three/fiber";
import {
	useGLTF,
	PresentationControls,
	Center,
	Environment,
} from "@react-three/drei";
import { Link } from "react-router-dom";

function Model(props) {
	const { scene } = useGLTF("/MapLevel1.glb");
	scene.castShadow = false;
	scene.receiveShadow = false;
	scene.traverse((child) => {
		if (child.isMesh) {
			child.castShadow = false;
			child.receiveShadow = false;
		}
	});

	return <primitive object={scene} {...props} />;
}

export default function Main() {
	const list = ["Stores", "Level", "Search", "Category", "Amenities", "Events"];

	return (
		<div className="w-full h-full">
			<div className="absolute w-full h-52 bg-slate-300 z-10 bottom-0 left-0 grid grid-cols-3 grid-rows-2">
				{list.map((item, index) => (
					<Link
						key={index}
						className="flex items-center justify-center"
						to={"/" + item.toLowerCase()}
					>
						<p>{item}</p>
					</Link>
				))}
			</div>
			<Canvas
				dpr={[1, 1]}
				camera={{ fov: 45 }}
				style={{ position: "absolute" }}
			>
				<color attach="background" args={["#fff"]} />
				<PresentationControls
					speed={1}
					global
					zoom={2}
					polar={[0.2, Math.PI / 4]}
				>
					<Environment preset="forest" />
					<Center environment={"forest"} shadows>
						<Model scale={4} castShadow={false} />
					</Center>
				</PresentationControls>
			</Canvas>
		</div>
	);
}
